import Loader from '@/components/loader'

export default function LoadingScreen() {
  return <Loader />
}
